module.exports = __webpack_public_path__ + "media/add-ons/workshop@2x-33fe81df.png";